function resetLocalStorage() {
	// Never clear or delete these key:
	// myCapitechLanguages
	// myCapitechLogin
	// myCapitechSettings

	// Reset keys
	setLocalStorage('myCapitechAccessTokenExpires','');
	setLocalStorage('myCapitechDimensionNames','');
	setLocalStorage('myCapitechDutyWishFilter', {departmentIds:[-1],dutyTypeIds:[-1], displayAvaliableDutiesOnDaysIAlreadyHaveOtherDuties:false});
	setLocalStorage('myCapitechDutyWishFilterValues', {departments:[],dutyTypes:[]});
	setLocalStorage('myCapitechExternalLinks','');
	setLocalStorage('myCapitechPermissionsAndRegistrationSetup','');
	setLocalStorage('myCapitechTimeCategoryForManualAddition','');
	setLocalStorage('myCapitechUnReadMessageCount','');
	setLocalStorage('myCapitechUserSettings','');

	// Delete old unused keys
	removeLocalStorage("myCapitechAccessToken");
	removeLocalStorage("myCapitechAuthorizeObj");
	removeLocalStorage("myCapitechLoginFormData");
}

function getLocalStorage(key) {
	if (('localStorage' in window) && window.localStorage !== null) {
		try {
			return JSON.parse(localStorage.getItem(getLocalStoragePrefix() + key));
		} catch(err) {
			return localStorage.getItem(getLocalStoragePrefix() + key);
		}
	} else {
		alert('LocalStorage er ikke støttet!');
	}
};

function setLocalStorage(key, value) {
	if (('localStorage' in window) && window.localStorage !== null) {
	  	if (value instanceof Array || value instanceof Object) {
			localStorage.setItem(getLocalStoragePrefix() + key, JSON.stringify(value));
		} else {
			localStorage.setItem(getLocalStoragePrefix() + key, value);
		}
	} else {
		alert('LocalStorage er ikke støttet!');
	}
};

function removeLocalStorage(key) {
	if (('localStorage' in window) && window.localStorage !== null) {
		localStorage.removeItem(getLocalStoragePrefix() + key);
	} else {
		alert('LocalStorage er ikke støttet!');
	}
};

function getLocalStoragePrefix() {
	var path = window.location.pathname;
	var aPath = path.split('/');
	var localStoragePath = aPath.slice(0, aPath.length - 1).join('');
	return localStoragePath;
}

function clearAllLocalStorage() {
	// Backup application settings
	var stampSettingsObj = getLocalStorage('stampSettings');
	var myCapitechSettingsObj = getLocalStorage('myCapitechSettings');
	// Empty localStorage
	localStorage.clear();
	// Restore stampSettingsObj into localStorage
	setLocalStorage('stampSettings', stampSettingsObj);
	setLocalStorage('myCapitechSettings', myCapitechSettingsObj);
}